// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { BasinId } from '../../core/models/BasinId'
import { MapType } from '../MapType'
import { ProductValues } from '../ProductValues'
import { TropicalTileCategory } from '../TropicalTileCategory'

/**
 * Encapsulates parameters used to make requests to [MapService].
 */
export class TilesByZxyRequest {
  /**
   * Gets or sets the map type.
   */
  public mapType: MapType

  /**
   * Gets or sets the tile frame date string.
   */
  public date: string

  /**
   * Gets or sets whether to include colors for global coverage reference.
   * Only used if [MapType] is [MapType.Radar].
   */
  public showColorTable = false // will there ever be values besides on/off?

  /**
   * Gets or sets a numerical value that can change the resultant rendered tiles.
   */
  public displayMode?: number

  /**
   * Gets or sets the products.
   * Only used if [MapType] is [MapType.Precipitation], [MapType.TwentyFourHourSnowfallForecast], or [MapType.TempContour].
   */
  public products?: ProductValues[] = []

  /**
   * Gets or sets the categories.
   * Only used if [MapType] is [MapType.Tropical].
   */
  public categories: TropicalTileCategory[]

  /**
   * Gets or sets the event key.
   * Only used if [MapType] is [MapType.Tropical].
   */
  public eventKey?: string

  /**
   * Gets or sets the basin IDs.
   * Only used if [MapType] is [MapType.Tropical].
   */
  public basinIds: BasinId[]

  /**
   * Gets or sets whether to include borders.
   * Only used if [MapType] is [MapType.WatchesAndWarnings].
   */
  public showBorders = false
  // todo: is 'borders' a valid query arg?
  // there is no difference passing either true|false

  /**
   * The ApiKey to be used in the tile url.
   */
  public apiKey: string

  /**
   * Initializes a new TilesByZxyRequest
   * @param mapType The map type.
   * @param date The tile frame date string. Not used if [MapType] is [MapType.Tropical] or [MapType.WatchesAndWarnings].
   */
  constructor(mapType: MapType, date = '') {
    this.mapType = mapType
    this.date = date
  }
}
